import 'components/carousels/JsCarousel.js';
import { OnNowCarouselPortraitBreakpoints, OnNowCarouselLandsCapeBreakpoints } from 'components/settings/BreakpointSettings';

export default function (customOptions = {}) {
    
    // sizes are 'small' or 'large' (default)
    let size = customOptions.size ? customOptions.size : 'large';
    // orientations are 'landscape' (default) or 'portrait'
    let orientation = customOptions.orientation ? customOptions.orientation : 'landscape';
    
    let wrapper = customOptions.parentContainer
        ? customOptions.parentContainer
        : $('.generic-carousel');

    let defaultOptions = {
        responsive: size == 'small' || orientation == 'portrait' ? OnNowCarouselPortraitBreakpoints : OnNowCarouselLandsCapeBreakpoints
    };

    let endOptions = $.extend(defaultOptions, customOptions.options);
    wrapper.JsCarousel(endOptions);
}
